
// import React from "react";
// import { motion } from "framer-motion";
// import {
//   Reveal,
//   staggerContainer,
//   revealUp,
//   zoomIn,
// } from "../common/Reveal";
// import { useTheme } from "../../context/ThemeContext";

// const EXAM_GROUPS = [
//   {
//     title: "Engineering Entrance Examinations",
//     icon: "⚙",
//     exams: [
//       ["MHT-CET", "Maharashtra Common Entrance Test"],
//       ["JEE Main", "Joint Entrance Examination Main"],
//       ["JEE Advanced", "Admission pathways to IITs"],
//       ["BITSAT", "Birla Institute of Technology and Science Admission Test"],
//       ["VITEEE", "VIT Engineering Entrance Examination"],
//     ],
//   },
//   {
//     title: "Medical Entrance Examination",
//     icon: "✚",
//     exams: [
//       ["NEET-UG", "National Eligibility-cum-Entrance Test for undergraduate medical programmes"],
//     ],
//   },
//   {
//     title: "Science & Research",
//     icon: "🔬",
//     exams: [
//       ["IAT", "IISER Aptitude Test for participating IISER programmes"],
//     ],
//   },
//   {
//     title: "Defence Entrance Examination",
//     icon: "★",
//     exams: [
//       ["NDA", "National Defence Academy and Naval Academy Examination"],
//     ],
//   },
//   {
//     title: "Architecture Entrance Examination",
//     icon: "⌂",
//     exams: [
//       ["NATA", "National Aptitude Test in Architecture"],
//     ],
//   },
// ];

// const ACADEMIC_CARDS = [
//   {
//     icon: "01",
//     title: "Concept-Based Teaching",
//     text: "We simplify complex concepts and focus on building a strong understanding of fundamental principles.",
//   },
//   {
//     icon: "02",
//     title: "Examination-Oriented Preparation",
//     text: "Question-solving techniques, examination patterns, practice strategies and performance improvement.",
//   },
//   {
//     icon: "03",
//     title: "Regular Testing & Analysis",
//     text: "Periodic tests help students evaluate preparation, identify weaknesses and monitor progress.",
//   },
//   {
//     icon: "04",
//     title: "Daily Practice Problems (DPPs)",
//     text: "Targeted practice problems reinforce classroom learning and improve accuracy, speed and confidence.",
//   },
//   {
//     icon: "05",
//     title: "Structured Study Material",
//     text: "Student-centric Gurukul booklets provide organised learning resources, revision support and examination-focused practice.",
//   },
//   {
//     icon: "06",
//     title: "Continuous Academic Support",
//     text: "Guidance to resolve doubts, strengthen difficult concepts and improve performance throughout the programme.",
//   },
// ];

// const MENTORSHIP_POINTS = [
//   "Understanding individual learning needs",
//   "Monitoring academic progress",
//   "Identifying weak concepts and topics",
//   "Providing doubt-solving support",
//   "Guiding students in study planning and revision",
//   "Improving time management and examination techniques",
//   "Building confidence and consistency",
//   "Encouraging students through challenging phases of preparation",
// ];

// const FACULTY_POINTS = [
//   "Strong conceptual understanding",
//   "Simple and effective explanation",
//   "Examination-oriented problem-solving",
//   "Systematic doubt resolution",
//   "Regular practice and revision",
//   "Individual academic guidance",
//   "Consistent monitoring of student progress",
// ];

// const STUDY_POINTS = [
//   "Understand concepts step by step",
//   "Practise questions systematically",
//   "Strengthen important topics",
//   "Identify recurring mistakes",
//   "Improve speed and accuracy",
//   "Revise effectively before examinations",
//   "Develop confidence in solving competitive-level questions",
// ];

// const TEST_POINTS = [
//   "Evaluate conceptual understanding",
//   "Assess topic-wise preparation",
//   "Identify weak areas",
//   "Analyse mistakes",
//   "Improve question-selection strategies",
//   "Strengthen revision planning",
//   "Track academic progress",
// ];

// const ENVIRONMENT_POINTS = [
//   "Academic discipline",
//   "Encouraging faculty interaction",
//   "Peer learning and healthy competition",
//   "Mentorship and motivation",
//   "Regular academic feedback",
//   "Student-centred support",
//   "Parent communication",
// ];

// const FACILITIES = [
//   {
//     icon: "BUS",
//     title: "Safe & Secure Bus Facility",
//     text: "Transportation facility intended to provide convenient access to the academy and support regular attendance.",
//   },
//   {
//     icon: "BOYS / GIRLS",
//     title: "Separate Hostel Facilities",
//     text: "Separate hostel facilities for boys and girls who require residential accommodation during their academic preparation.",
//   },
//   {
//     icon: "COLLEGE",
//     title: "College & Integrated Learning",
//     text: "The academy's educational ecosystem includes its own college facilities to support integrated academic learning and competitive preparation, subject to programme and admission arrangements.",
//   },
// ];

// const SCHOLARSHIP_POINTS = [
//   "Available courses and fee structures",
//   "Merit-based scholarships",
//   "Scholarship eligibility criteria",
//   "Applicable concessions",
//   "Payment schedules and options",
//   "Admission and enrolment procedures",
// ];

// const ADVANTAGES = [
//   {
//     title: "Established in 2018",
//     text: "A focused journey in competitive examination preparation.",
//   },
//   {
//     title: "Results Since 2020",
//     text: "A commitment to student performance and academic outcomes.",
//   },
//   {
//     title: "Multiple Entrance Exams",
//     text: "Preparation across engineering, medical, science, defence and architecture pathways.",
//   },
//   {
//     title: "Experienced Faculty",
//     text: "Expert teaching with a focus on conceptual clarity.",
//   },
//   {
//     title: "Individual Attention",
//     text: "Support tailored to student learning needs.",
//   },
//   {
//     title: "Personal Mentorship",
//     text: "Guidance for academic progress and examination preparation.",
//   },
//   {
//     title: "Result-Oriented Programmes",
//     text: "Structured preparation with clear academic goals.",
//   },
//   {
//     title: "Periodic Tests",
//     text: "Regular assessment and performance review.",
//   },
//   {
//     title: "Gurukul Booklets & DPPs",
//     text: "Organised study material and targeted practice.",
//   },
//   {
//     title: "Simple & Effective Teaching",
//     text: "Making complex concepts easier to understand.",
//   },
//   {
//     title: "Expert Guidance",
//     text: "Access to subject specialists and relevant industry expertise, where applicable.",
//   },
//   {
//     title: "Own College Facilities",
//     text: "Support for integrated academic pathways where available.",
//   },
//   {
//     title: "Safe Transportation",
//     text: "Convenient travel support for students.",
//   },
//   {
//     title: "Separate Hostels",
//     text: "Residential options for boys and girls.",
//   },
//   {
//     title: "Flexible Fee Structure",
//     text: "Options explained according to programme requirements.",
//   },
//   {
//     title: "Merit Scholarships",
//     text: "Opportunities for eligible, meritorious students.",
//   },
//   {
//     title: "Parent-Friendly Management",
//     text: "Communication and cooperation with families.",
//   },
//   {
//     title: "Supportive Atmosphere",
//     text: "An environment that encourages discipline, confidence and continuous improvement.",
//   },
// ];

// const STATISTICS = [
//   { value: "2018", label: "Year Established" },
//   { value: "2020", label: "Results Journey Since" },
//   { value: "5+", label: "Engineering Entrance Exams" },
//   { value: "360°", label: "Student-Focused Support" },
// ];

// const SectionHead = ({ title, sub }) => (
//   <motion.div
//     className="im-head"
//     variants={staggerContainer}
//     initial="hidden"
//     whileInView="show"
//     viewport={{ once: true }}
//   >
//     <Reveal
//       as={motion.h2}
//       variants={revealUp}
//       className="im-title"
//     >
//       {title}
//     </Reveal>

//     {sub && (
//       <Reveal
//         as={motion.p}
//         variants={revealUp}
//         className="im-sub"
//       >
//         {sub}
//       </Reveal>
//     )}
//   </motion.div>
// );

// const InfoCard = ({ icon, title, text }) => (
//   <Reveal
//     as={motion.article}
//     variants={zoomIn}
//     className="im-card"
//   >
//     {icon && <div className="im-icon">{icon}</div>}
//     <h3 className="im-card-title">{title}</h3>
//     <p className="im-card-text">{text}</p>
//   </Reveal>
// );

// const PointList = ({ items }) => (
//   <div className="im-points">
//     {items.map((item, index) => (
//       <div className="im-point" key={`${item}-${index}`}>
//         <span className="im-check">✓</span>
//         <span>{item}</span>
//       </div>
//     ))}
//   </div>
// );

// const IITMedicalAcademyShowcase = () => {
//   const { colors } = useTheme();

//   const rootStyle = {
//     "--im-primary": colors.primary,
//     "--im-primary-dark": colors.primaryDark,
//     "--im-secondary": colors.secondary,
//     "--im-text": colors.text,
//     "--im-text2": colors.textSecondary,
//     "--im-bg": colors.background,
//     "--im-bg-alt": colors.backgroundAlt,
//     "--im-card": colors.card,
//     "--im-border": colors.border,
//     "--im-shadow": colors.cardShadow,
//     "--im-button": colors.buttonPrimary,
//     "--im-button-text": colors.buttonText,
//     "--im-hover": colors.hover,
//   };

//   const goTo = (id) => {
//     const element = document.getElementById(id);

//     if (element) {
//       element.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   };

//   return (
//     <div className="im-root" style={rootStyle}>
//       <style>{`
//         .im-root {
//           width: 100%;
//           overflow: hidden;
//           color: var(--im-text);
//           background: var(--im-bg);
//           font-family: inherit;
//           line-height: 1.65;
//           isolation: isolate;
//         }

//         .im-root * {
//           box-sizing: border-box;
//         }

//         .im-section {
//           padding: 4rem 1.5rem;
//           scroll-margin-top: 110px;
//         }

//         .im-section-alt {
//           background: var(--im-bg-alt);
//         }

//         .im-wrap {
//           width: 100%;
//           max-width: 1240px;
//           margin: 0 auto;
//         }

//         .im-head {
//           max-width: 900px;
//           margin: 0 auto 2.5rem;
//           text-align: center;
//         }

//         .im-title {
//           margin: 0 0 .75rem;
//           font-size: clamp(1.8rem, 3vw, 2.5rem);
//           font-weight: 700;
//           line-height: 1.3;
//           letter-spacing: -.025em;
//           color: var(--im-text);
//         }

//         .im-title::after {
//           content: "";
//           display: block;
//           width: 54px;
//           height: 3px;
//           margin: .8rem auto 0;
//           border-radius: 5px;
//           background: linear-gradient(
//             90deg,
//             var(--im-primary),
//             var(--im-primary-dark)
//           );
//         }

//         .im-sub {
//           max-width: 820px;
//           margin: 0 auto;
//           color: var(--im-text2);
//           font-size: 1rem;
//           line-height: 1.8;
//         }

//         .im-grid {
//           display: grid;
//           grid-template-columns: repeat(3, minmax(0, 1fr));
//           gap: 1.35rem;
//         }

//         .im-grid-2 {
//           grid-template-columns: repeat(2, minmax(0, 1fr));
//         }

//         .im-grid-4 {
//           grid-template-columns: repeat(4, minmax(0, 1fr));
//         }

//         .im-card {
//           min-width: 0;
//           height: 100%;
//           padding: 1.6rem;
//           border: 1px solid var(--im-border);
//           border-radius: 16px;
//           background: var(--im-card);
//           box-shadow: var(--im-shadow);
//           transition:
//             transform .25s ease,
//             border-color .25s ease,
//             box-shadow .25s ease;
//         }

//         .im-card:hover {
//           transform: translateY(-4px);
//           border-color: color-mix(
//             in srgb,
//             var(--im-primary) 55%,
//             var(--im-border)
//           );
//         }

//         .im-icon {
//           display: inline-flex;
//           align-items: center;
//           justify-content: center;
//           min-width: 46px;
//           min-height: 46px;
//           margin-bottom: 1rem;
//           padding: .65rem;
//           border: 1px solid var(--im-border);
//           border-radius: 12px;
//           background: var(--im-bg-alt);
//           color: var(--im-primary);
//           font-size: .95rem;
//           font-weight: 800;
//         }

//         .im-card-title {
//           margin: 0 0 .65rem;
//           color: var(--im-text);
//           font-size: 1.15rem;
//           line-height: 1.45;
//           font-weight: 700;
//         }

//         .im-card-text {
//           margin: 0;
//           color: var(--im-text2);
//           font-size: .96rem;
//           line-height: 1.75;
//           overflow-wrap: anywhere;
//         }

//         .im-hero {
//           padding-top: 4.5rem;
//           padding-bottom: 4.5rem;
//           background: var(
//             --im-bg-gradient,
//             linear-gradient(
//               135deg,
//               var(--im-bg-alt),
//               var(--im-bg)
//             )
//           );
//         }

//         .im-hero-layout {
//           display: grid;
//           grid-template-columns: 1.2fr .8fr;
//           align-items: center;
//           gap: 3rem;
//         }

//         .im-eyebrow {
//           display: inline-flex;
//           align-items: center;
//           margin-bottom: 1.25rem;
//           padding: .45rem .85rem;
//           border: 1px solid var(--im-border);
//           border-radius: 999px;
//           background: var(--im-card);
//           color: var(--im-primary);
//           font-size: .84rem;
//           font-weight: 700;
//           letter-spacing: .04em;
//         }

//         .im-hero-title {
//           margin: 0 0 1.25rem;
//           font-size: clamp(2.2rem, 4.5vw, 3.65rem);
//           font-weight: 800;
//           line-height: 1.15;
//           letter-spacing: -.035em;
//           color: var(--im-text);
//           text-wrap: balance;
//         }

//         .im-gradient-text {
//           background: linear-gradient(
//             120deg,
//             var(--im-primary),
//             var(--im-primary-dark)
//           );
//           -webkit-background-clip: text;
//           background-clip: text;
//           -webkit-text-fill-color: transparent;
//           color: transparent;
//         }

//         .im-hero-lead {
//           margin: 0 0 1.15rem;
//           color: var(--im-text2);
//           font-size: 1.02rem;
//           line-height: 1.85;
//         }

//         .im-tagline {
//           margin: 0 0 1.1rem;
//           color: var(--im-primary);
//           font-size: 1rem;
//           font-weight: 700;
//         }

//         .im-chips {
//           display: flex;
//           flex-wrap: wrap;
//           gap: .6rem;
//           margin: 1.3rem 0 1.7rem;
//         }

//         .im-chip {
//           padding: .45rem .8rem;
//           border: 1px solid var(--im-border);
//           border-radius: 999px;
//           background: var(--im-card);
//           color: var(--im-text);
//           font-size: .86rem;
//           font-weight: 600;
//         }

//         .im-actions {
//           display: flex;
//           flex-wrap: wrap;
//           gap: .85rem;
//           margin-top: 1.5rem;
//         }

//         .im-btn {
//           display: inline-flex;
//           align-items: center;
//           justify-content: center;
//           min-height: 46px;
//           padding: .8rem 1.25rem;
//           border: 1px solid var(--im-border);
//           border-radius: 9px;
//           background: var(--im-card);
//           color: var(--im-text);
//           font: inherit;
//           font-size: .95rem;
//           font-weight: 650;
//           text-align: center;
//           cursor: pointer;
//           transition: transform .2s ease, opacity .2s ease;
//         }

//         .im-btn:hover {
//           transform: translateY(-2px);
//         }

//         .im-btn-primary {
//           border-color: transparent;
//           background: var(--im-button, var(--im-primary));
//           color: var(--im-button-text, #fff);
//         }

//         .im-hero-panel {
//           padding: 1.6rem;
//           border: 1px solid var(--im-border);
//           border-radius: 20px;
//           background: var(--im-card);
//           box-shadow: var(--im-shadow);
//         }

//         .im-panel-label {
//           margin: 0 0 1.2rem;
//           color: var(--im-text2);
//           font-size: .9rem;
//           font-weight: 600;
//         }

//         .im-panel-item {
//           display: flex;
//           align-items: flex-start;
//           gap: .9rem;
//           padding: .95rem 0;
//           border-bottom: 1px solid var(--im-border);
//         }

//         .im-panel-item:last-child {
//           padding-bottom: 0;
//           border-bottom: 0;
//         }

//         .im-panel-number {
//           display: flex;
//           flex: 0 0 38px;
//           align-items: center;
//           justify-content: center;
//           width: 38px;
//           height: 38px;
//           border-radius: 10px;
//           background: var(--im-bg-alt);
//           color: var(--im-primary);
//           font-size: .9rem;
//           font-weight: 800;
//         }

//         .im-panel-item strong {
//           display: block;
//           color: var(--im-text);
//           font-size: .95rem;
//         }

//         .im-panel-item span {
//           display: block;
//           margin-top: .2rem;
//           color: var(--im-text2);
//           font-size: .83rem;
//         }

//         .im-stat {
//           text-align: center;
//           padding: 1.5rem 1rem;
//         }

//         .im-stat-value {
//           color: var(--im-primary);
//           font-size: clamp(1.7rem, 3vw, 2.4rem);
//           font-weight: 800;
//           line-height: 1.2;
//         }

//         .im-stat-label {
//           margin-top: .55rem;
//           color: var(--im-text2);
//           font-size: .9rem;
//         }

//         .im-callout {
//           margin-top: 2rem;
//           padding: 1.35rem 1.5rem;
//           border: 1px solid var(--im-border);
//           border-left: 4px solid var(--im-primary);
//           border-radius: 12px;
//           background: var(--im-card);
//           color: var(--im-text);
//           font-size: 1rem;
//           line-height: 1.8;
//         }

//         .im-points {
//           display: grid;
//           grid-template-columns: repeat(2, minmax(0, 1fr));
//           gap: .8rem;
//         }

//         .im-point {
//           display: flex;
//           align-items: flex-start;
//           gap: .75rem;
//           min-width: 0;
//           padding: .9rem 1rem;
//           border: 1px solid var(--im-border);
//           border-radius: 12px;
//           background: var(--im-card);
//           color: var(--im-text2);
//           font-size: .94rem;
//           line-height: 1.65;
//         }

//         .im-check {
//           display: inline-flex;
//           flex: 0 0 25px;
//           align-items: center;
//           justify-content: center;
//           width: 25px;
//           height: 25px;
//           border-radius: 50%;
//           background: var(--im-bg-alt);
//           color: var(--im-primary);
//           font-weight: 800;
//         }

//         .im-exam-card {
//           display: flex;
//           flex-direction: column;
//           gap: .85rem;
//         }

//         .im-exam-list {
//           display: grid;
//           gap: .7rem;
//           margin-top: .2rem;
//         }

//         .im-exam-item {
//           padding: .85rem;
//           border: 1px solid var(--im-border);
//           border-radius: 10px;
//           background: var(--im-bg);
//         }

//         .im-exam-item strong {
//           display: block;
//           margin-bottom: .25rem;
//           color: var(--im-primary);
//           font-size: .98rem;
//         }

//         .im-exam-item span {
//           display: block;
//           color: var(--im-text2);
//           font-size: .87rem;
//           line-height: 1.6;
//         }

//         .im-banner {
//           padding: 3rem 2rem;
//           border: 1px solid var(--im-border);
//           border-radius: 18px;
//           background: var(--im-card);
//           text-align: center;
//           box-shadow: var(--im-shadow);
//         }

//         .im-banner h3 {
//           margin: 0 0 .85rem;
//           color: var(--im-text);
//           font-size: clamp(1.5rem, 3vw, 2.2rem);
//           line-height: 1.35;
//         }

//         .im-banner p {
//           max-width: 800px;
//           margin: 0 auto;
//           color: var(--im-text2);
//           line-height: 1.8;
//         }

//         .im-final {
//           padding: 4rem 1.5rem;
//           background: var(--im-bg-alt);
//         }

//         .im-final-inner {
//           max-width: 950px;
//           margin: 0 auto;
//           text-align: center;
//         }

//         .im-final-title {
//           margin: 0 0 1rem;
//           color: var(--im-text);
//           font-size: clamp(2rem, 4vw, 3rem);
//           font-weight: 800;
//           line-height: 1.2;
//           letter-spacing: -.03em;
//         }

//         .im-final-text {
//           max-width: 800px;
//           margin: 0 auto;
//           color: var(--im-text2);
//           line-height: 1.8;
//         }

//         .im-footer-name {
//           margin-top: 2rem;
//           color: var(--im-text);
//           font-weight: 800;
//           letter-spacing: .02em;
//         }

//         .im-footer-tagline {
//           margin-top: .5rem;
//           color: var(--im-primary);
//           font-weight: 650;
//         }

//         @media (max-width: 1024px) {
//           .im-grid-4 {
//             grid-template-columns: repeat(2, minmax(0, 1fr));
//           }

//           .im-hero-layout {
//             grid-template-columns: 1fr 1fr;
//             gap: 1.5rem;
//           }
//         }

//         @media (max-width: 768px) {
//           .im-section {
//             padding: 2.8rem 1rem;
//           }

//           .im-grid,
//           .im-grid-2,
//           .im-grid-4 {
//             grid-template-columns: repeat(2, minmax(0, 1fr));
//             gap: 1rem;
//           }

//           .im-hero-layout {
//             grid-template-columns: 1fr;
//             gap: 1.5rem;
//           }

//           .im-hero {
//             padding-top: 3rem;
//             padding-bottom: 3rem;
//           }

//           .im-hero-title {
//             font-size: clamp(2rem, 7vw, 2.7rem);
//           }

//           .im-card {
//             padding: 1.2rem;
//             border-radius: 14px;
//           }

//           .im-card-title {
//             font-size: 1.05rem;
//           }

//           .im-card-text {
//             font-size: .92rem;
//           }

//           .im-points {
//             grid-template-columns: 1fr;
//           }

//           .im-head {
//             margin-bottom: 1.8rem;
//           }

//           .im-title {
//             font-size: clamp(1.55rem, 5vw, 2rem);
//           }

//           .im-hero-panel {
//             padding: 1.2rem;
//           }
//         }

//         @media (max-width: 480px) {
//           .im-section {
//             padding: 2.3rem .9rem;
//           }

//           .im-grid,
//           .im-grid-2,
//           .im-grid-4 {
//             grid-template-columns: minmax(0, 1fr);
//           }

//           .im-hero-title {
//             font-size: 2rem;
//           }

//           .im-hero-lead {
//             font-size: .94rem;
//           }

//           .im-actions {
//             flex-direction: column;
//           }

//           .im-btn {
//             width: 100%;
//           }

//           .im-stat {
//             padding: 1.15rem .75rem;
//           }

//           .im-banner {
//             padding: 2rem 1rem;
//           }

//           .im-final {
//             padding: 3rem 1rem;
//           }
//         }

//         @media (prefers-reduced-motion: reduce) {
//           .im-card,
//           .im-btn {
//             transition: none;
//           }

//           .im-card:hover,
//           .im-btn:hover {
//             transform: none;
//           }
//         }
//       `}</style>

//       {/* 01 — HERO */}

//       <section id="im-hero" className="im-section im-hero">
//         <div className="im-wrap im-hero-layout">
//           <div>
//             <span className="im-eyebrow">
//               A Unit of GURUKULM | Gurukul Academy
//             </span>

//             <h1 className="im-hero-title">
//               Your Ambition.
//               <br />
//               Our Guidance.
//               <br />
//               <span className="im-gradient-text">
//                 Your Success.
//               </span>
//             </h1>

//             <p className="im-tagline">
//               Dream Big. Prepare Smart. Achieve Excellence.
//             </p>

//             <p className="im-hero-lead">
//               Established in 2018, Gurukul IIT & Medical Academy
//               is committed to helping students achieve their
//               dreams of entering premier engineering, medical,
//               science, defence, architecture and other professional
//               institutions.
//             </p>

//             <p className="im-hero-lead">
//               Since 2020, our academy has been delivering impressive
//               entrance examination results, reflecting our commitment
//               to quality teaching, focused preparation and continuous
//               student support.
//             </p>

//             <div className="im-chips">
//               <span className="im-chip">JEE</span>
//               <span className="im-chip">NEET</span>
//               <span className="im-chip">MHT-CET</span>
//               <span className="im-chip">BITSAT</span>
//               <span className="im-chip">VITEEE</span>
//               <span className="im-chip">NDA</span>
//               <span className="im-chip">NATA</span>
//             </div>

//             <div className="im-actions">
//               <button
//                 className="im-btn im-btn-primary"
//                 onClick={() => goTo("im-exams")}
//               >
//                 Explore Courses
//               </button>

//               <button
//                 className="im-btn"
//                 onClick={() => goTo("im-admissions")}
//               >
//                 Admission Enquiry
//               </button>
//             </div>
//           </div>

//           <div className="im-hero-panel">
//             <p className="im-panel-label">
//               One Academy. Multiple Opportunities.
//             </p>

//             {[
//               ["01", "Strong Concepts", "Build a clear understanding"],
//               ["02", "Smart Preparation", "Practise with a focused plan"],
//               ["03", "Personal Mentorship", "Get individual academic guidance"],
//               ["04", "Performance Analysis", "Identify gaps and improve"],
//             ].map(([number, title, text]) => (
//               <div className="im-panel-item" key={number}>
//                 <div className="im-panel-number">{number}</div>
//                 <div>
//                   <strong>{title}</strong>
//                   <span>{text}</span>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* 02 — AT A GLANCE */}

//       <section id="im-overview" className="im-section im-section-alt">
//         <div className="im-wrap">
//           <SectionHead
//             title="Gurukul at a Glance"
//             sub="A focused learning ecosystem built around academic discipline, individual attention and competitive examination preparation."
//           />

//           <div className="im-grid im-grid-4">
//             {STATISTICS.map((stat) => (
//               <Reveal
//                 as={motion.div}
//                 variants={zoomIn}
//                 className="im-card im-stat"
//                 key={stat.label}
//               >
//                 <div className="im-stat-value">{stat.value}</div>
//                 <div className="im-stat-label">{stat.label}</div>
//               </Reveal>
//             ))}
//           </div>

//           <div className="im-callout">
//             One Academy. Multiple Opportunities. A Future Without Limits.
//           </div>
//         </div>
//       </section>

//       {/* 03 — OUR JOURNEY */}

//       <section id="im-journey" className="im-section">
//         <div className="im-wrap">
//           <SectionHead
//             title="Our Journey"
//             sub="Established in 2018. Creating Success Stories Since 2020."
//           />

//           <div className="im-grid im-grid-2">
//             <InfoCard
//               icon="2018"
//               title="A Vision for Competitive Learning"
//               text="Gurukul IIT & Medical Academy was established with a vision to provide quality competitive examination coaching supported by academic discipline, personal mentorship and a student-first approach."
//             />

//             <InfoCard
//               icon="2020"
//               title="A Focus on Student Performance"
//               text="Since 2020, the academy has been helping aspiring students prepare for a wide range of competitive entrance examinations through systematic teaching, regular assessments and focused performance improvement."
//             />
//           </div>

//           <div className="im-callout">
//             Every student has a different learning pace, strengths and
//             aspirations. We combine strong conceptual foundations with
//             examination-oriented preparation to help students progress
//             towards their individual goals.
//           </div>
//         </div>
//       </section>

//       {/* 04 — ENTRANCE EXAMINATIONS */}

//       <section id="im-exams" className="im-section im-section-alt">
//         <div className="im-wrap">
//           <SectionHead
//             title="Comprehensive Entrance Examination Preparation"
//             sub="One Destination for Multiple Career Pathways"
//           />

//           <p className="im-card-text" style={{ marginBottom: "1.5rem" }}>
//             Gurukul IIT & Medical Academy provides coaching for a wide
//             range of entrance examinations, helping students prepare
//             for opportunities across engineering, medicine, science,
//             defence and architecture.
//           </p>

//           <div className="im-grid im-grid-2">
//             {EXAM_GROUPS.map((group) => (
//               <Reveal
//                 as={motion.article}
//                 variants={zoomIn}
//                 className="im-card im-exam-card"
//                 key={group.title}
//               >
//                 <div className="im-icon">{group.icon}</div>
//                 <h3 className="im-card-title">{group.title}</h3>

//                 <div className="im-exam-list">
//                   {group.exams.map(([name, description]) => (
//                     <div className="im-exam-item" key={name}>
//                       <strong>{name}</strong>
//                       <span>{description}</span>
//                     </div>
//                   ))}
//                 </div>
//               </Reveal>
//             ))}

//             <InfoCard
//               icon="＋"
//               title="Other Entrance Examinations"
//               text="Contact the academy to learn about other entrance examinations and the preparation options available."
//             />
//           </div>

//           <div className="im-callout">
//             Multiple Exams. Multiple Opportunities. One Focused Preparation
//             Journey.
//           </div>
//         </div>
//       </section>

//       {/* 05 — ACADEMIC APPROACH */}

//       <section id="im-academics" className="im-section">
//         <div className="im-wrap">
//           <SectionHead
//             title="Our Academic Approach"
//             sub="Result-Oriented. Student-Centred. Performance-Driven."
//           />

//           <p className="im-card-text" style={{ marginBottom: "1.5rem" }}>
//             Success in competitive examinations requires more than
//             completing the syllabus. It demands conceptual clarity,
//             disciplined practice, time management, accuracy and the
//             ability to perform under pressure. Our academic programme
//             is designed to bring these elements together.
//           </p>

//           <div className="im-grid">
//             {ACADEMIC_CARDS.map((item) => (
//               <InfoCard
//                 key={item.title}
//                 icon={item.icon}
//                 title={item.title}
//                 text={item.text}
//               />
//             ))}
//           </div>

//           <div className="im-callout">
//             Learn the Concept. Practise the Questions. Master the Examination.
//           </div>
//         </div>
//       </section>

//       {/* 06 — INDIVIDUAL ATTENTION */}

//       <section id="im-mentorship" className="im-section im-section-alt">
//         <div className="im-wrap">
//           <SectionHead
//             title="Sukshma Drashta"
//             sub="Individual Attention & Personal Mentorship"
//           />

//           <div className="im-grid im-grid-2">
//             <InfoCard
//               icon="01"
//               title="Every Student Matters"
//               text="Every Goal Deserves a Plan. We believe students perform better when their academic needs are understood and supported."
//             />

//             <InfoCard
//               icon="02"
//               title="Personalised Academic Guidance"
//               text="Our individual attention and mentorship approach aims to identify each student's strengths, learning gaps and improvement areas, helping them prepare with greater confidence and direction."
//             />
//           </div>

//           <h3 className="im-card-title" style={{ margin: "2rem 0 1rem" }}>
//             Our Student Support System
//           </h3>

//           <PointList items={MENTORSHIP_POINTS} />

//           <div className="im-callout">
//             Through mentorship and regular interaction, we strive to ensure
//             that students do not feel alone in their competitive examination
//             journey.
//             <br />
//             <strong>
//               Personal Attention. Purposeful Guidance. Continuous Improvement.
//             </strong>
//           </div>
//         </div>
//       </section>

//       {/* 07 — FACULTY */}

//       <section id="im-faculty" className="im-section">
//         <div className="im-wrap">
//           <SectionHead
//             title="Experienced & Dedicated Faculty"
//             sub="Expert Teaching. Clear Concepts. Strong Foundations."
//           />

//           <p className="im-card-text" style={{ marginBottom: "1.5rem" }}>
//             Our faculty team is central to the Gurukul learning experience.
//             Experienced and dedicated educators help students understand
//             challenging topics, develop problem-solving abilities and
//             approach competitive examinations with clarity.
//           </p>

//           <PointList items={FACULTY_POINTS} />

//           <div className="im-callout">
//             Students also benefit from expert guidance and relevant
//             interactions with industry professionals, subject specialists
//             and other experts, wherever applicable.
//             <br />
//             <strong>
//               Learn from Experts. Think Independently. Perform with Confidence.
//             </strong>
//           </div>
//         </div>
//       </section>

//       {/* 08 — STUDY MATERIAL */}

//       <section id="im-study-material" className="im-section im-section-alt">
//         <div className="im-wrap">
//           <SectionHead
//             title="Gurukul Study Material & DPP System"
//             sub="Designed for Practice. Built for Performance."
//           />

//           <p className="im-card-text" style={{ marginBottom: "1.5rem" }}>
//             Effective preparation requires the right learning resources
//             and consistent practice. Gurukul IIT & Medical Academy provides
//             student-centric Gurukul booklets and Daily Practice Problems
//             (DPPs) to support classroom learning and examination preparation.
//           </p>

//           <PointList items={STUDY_POINTS} />

//           <div className="im-callout">
//             Our focus is on making learning organised, purposeful and easier
//             to follow.
//             <br />
//             <strong>
//               Understand Better. Practise Regularly. Improve Continuously.
//             </strong>
//           </div>
//         </div>
//       </section>

//       {/* 09 — TESTING AND ANALYSIS */}

//       <section id="im-testing" className="im-section">
//         <div className="im-wrap">
//           <SectionHead
//             title="Periodic Tests & Performance Analysis"
//             sub="Measure Progress. Identify Gaps. Improve Results."
//           />

//           <p className="im-card-text" style={{ marginBottom: "1.5rem" }}>
//             Regular testing is an essential part of competitive examination
//             preparation. Our periodic assessment system helps students
//             become familiar with examination conditions while developing
//             accuracy, speed, time management and confidence.
//           </p>

//           <PointList items={TEST_POINTS} />

//           <div className="im-banner" style={{ marginTop: "2rem" }}>
//             <h3>Every Test Is an Opportunity to Improve.</h3>
//             <p>
//               Tests are not merely a way to measure performance; they are
//               an opportunity to learn, improve and prepare more effectively.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* 10 — LEARNING ENVIRONMENT */}

//       <section id="im-environment" className="im-section im-section-alt">
//         <div className="im-wrap">
//           <SectionHead
//             title="Supportive Learning Environment"
//             sub="Ambition Needs the Right Environment."
//           />

//           <p className="im-card-text" style={{ marginBottom: "1.5rem" }}>
//             Preparing for competitive examinations can be demanding.
//             Students need an environment that encourages discipline,
//             healthy competition, consistent effort and emotional confidence.
//             At Gurukul IIT & Medical Academy, we strive to create a supportive
//             atmosphere where students can ask questions, seek guidance,
//             learn from mistakes and remain focused on their goals.
//           </p>

//           <PointList items={ENVIRONMENT_POINTS} />

//           <div className="im-callout">
//             We aim to help students develop not only examination skills but
//             also perseverance, responsibility and self-belief.
//           </div>
//         </div>
//       </section>

//       {/* 11 — INTEGRATED LEARNING AND FACILITIES */}

//       <section id="im-facilities" className="im-section">
//         <div className="im-wrap">
//           <SectionHead
//             title="College & Integrated Learning Support"
//             sub="A Connected Academic Journey."
//           />

//           <p className="im-card-text" style={{ marginBottom: "1.5rem" }}>
//             Access to a structured academic environment helps students
//             manage school or college studies alongside entrance examination
//             preparation. Our approach aims to connect foundational academic
//             concepts with competitive examination requirements.
//           </p>

//           <div className="im-grid">
//             {FACILITIES.map((facility) => (
//               <InfoCard
//                 key={facility.title}
//                 icon={facility.icon}
//                 title={facility.title}
//                 text={facility.text}
//               />
//             ))}
//           </div>

//           <div className="im-callout">
//             Students and parents can contact the academy to understand
//             available integrated programmes, academic schedules and
//             admission pathways.
//           </div>
//         </div>
//       </section>

//       {/* 12 — FEES AND SCHOLARSHIPS */}

//       <section id="im-scholarships" className="im-section im-section-alt">
//         <div className="im-wrap">
//           <SectionHead
//             title="Flexible Fee Structure & Merit Scholarships"
//             sub="Encouraging Merit. Expanding Opportunities."
//           />

//           <div className="im-grid im-grid-2">
//             <InfoCard
//               icon="₹"
//               title="Flexible Fee Structure"
//               text="Our approach aims to support families in exploring suitable academic options while explaining fees according to programme requirements."
//             />

//             <InfoCard
//               icon="★"
//               title="Merit-Based Scholarships"
//               text="Scholarship opportunities are available subject to the applicable programme, eligibility criteria and scholarship terms."
//             />
//           </div>

//           <h3 className="im-card-title" style={{ margin: "2rem 0 1rem" }}>
//             Contact the Academy to Learn About
//           </h3>

//           <PointList items={SCHOLARSHIP_POINTS} />

//           <div className="im-callout">
//             Recognising Merit. Encouraging Ambition. Supporting Potential.
//           </div>
//         </div>
//       </section>

//       {/* 13 — PARENT-FRIENDLY MANAGEMENT */}

//       <section id="im-parents" className="im-section">
//         <div className="im-wrap">
//           <SectionHead
//             title="Parent-Friendly Management"
//             sub="A Partnership Built on Trust."
//           />

//           <div className="im-grid im-grid-2">
//             <InfoCard
//               icon="01"
//               title="Transparent Communication"
//               text="We value transparent communication, accessible guidance and constructive parent engagement."
//             />

//             <InfoCard
//               icon="02"
//               title="Family & Faculty Partnership"
//               text="Our approach aims to provide families with clarity regarding academic progress, student performance, course expectations and available support."
//             />
//           </div>

//           <div className="im-callout">
//             We encourage parents to work in partnership with faculty and
//             mentors so that students receive consistent guidance both at
//             home and at the academy.
//             <br />
//             <strong>
//               When Parents and Educators Work Together, Students Move Forward
//               with Confidence.
//             </strong>
//           </div>
//         </div>
//       </section>

//       {/* 14 — THE GURUKUL ADVANTAGE */}

//       <section id="im-advantage" className="im-section im-section-alt">
//         <div className="im-wrap">
//           <SectionHead
//             title="The Gurukul Advantage"
//             sub="Why do students and parents choose Gurukul IIT & Medical Academy?"
//           />

//           <div className="im-grid im-grid-2">
//             {ADVANTAGES.map((advantage, index) => (
//               <InfoCard
//                 key={advantage.title}
//                 icon={String(index + 1).padStart(2, "0")}
//                 title={advantage.title}
//                 text={advantage.text}
//               />
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* OUR COMMITMENT */}

//       <section id="im-commitment" className="im-section">
//         <div className="im-wrap">
//           <SectionHead
//             title="Our Commitment"
//             sub="We Prepare Students for Opportunities, Not Just Examinations."
//           />

//           <div className="im-banner">
//             <h3>
//               Your Dream Deserves Direction.
//               <br />
//               Your Effort Deserves Guidance.
//             </h3>

//             <p>
//               At Gurukul IIT & Medical Academy, we understand that every
//               student has a dream, and every dream deserves focused
//               preparation. Our commitment is to provide the academic
//               guidance, structured practice, mentorship and supportive
//               environment that students need to work towards their
//               aspirations.
//             </p>

//             <p style={{ marginTop: "1rem" }}>
//               We encourage students to aim high, work consistently, learn
//               from setbacks and approach every challenge with confidence.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* ADMISSIONS OPEN */}

//       <section id="im-admissions" className="im-final">
//         <div className="im-final-inner">
//           <span className="im-eyebrow">Admissions Open</span>

//           <h2 className="im-final-title">
//             Your Journey to a Dream Career Starts Here.
//           </h2>

//           <p className="im-final-text">
//             Preparing for JEE, NEET, MHT-CET, BITSAT, VITEEE, IAT,
//             NDA, NATA or another entrance examination?
//           </p>

//           <p className="im-final-text" style={{ marginTop: "1rem" }}>
//             Choose a learning environment that combines expert faculty,
//             individual attention, structured testing, mentorship and
//             student-focused academic support.
//           </p>

//           <div
//             className="im-actions"
//             style={{ justifyContent: "center" }}
//           >
//             <button
//               className="im-btn im-btn-primary"
//               onClick={() => goTo("im-exams")}
//             >
//               Explore Entrance Exams
//             </button>

//             <button
//               className="im-btn"
//               onClick={() => {
//                 const element = document.getElementById("admission-inquiry");

//                 if (element) {
//                   element.scrollIntoView({
//                     behavior: "smooth",
//                     block: "start",
//                   });
//                 } else {
//                   goTo("im-contact");
//                 }
//               }}
//             >
//               Enquire for Admission
//             </button>
//           </div>

//           <div className="im-footer-name">
//             GURUKUL IIT & MEDICAL ACADEMY
//           </div>

//           <div className="im-final-text">
//             A Unit of GURUKULM | Gurukul Academy
//           </div>

//           <div className="im-footer-tagline">
//             Dream Big. Prepare Smart. Achieve Excellence.
//           </div>

//           <p className="im-final-text" style={{ marginTop: "1rem" }}>
//             Contact the Academy for Course Details, Scholarships,
//             Fees and Admissions.
//           </p>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default IITMedicalAcademyShowcase;

import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { useTheme } from "../../context/ThemeContext";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?auto=format&fit=crop&w=2000&q=85";

const JOURNEY = [
  {
    year: "2018",
    title: "The Beginning",
    text: "Gurukul IIT & Medical Academy was established with a vision to provide quality competitive examination coaching, academic discipline and personal mentorship.",
    icon: "calendar",
  },
  {
    year: "2020",
    title: "Results Since 2020",
    text: "The academy began building its journey of entrance examination results through systematic teaching, regular assessments and focused performance improvement.",
    icon: "trophy",
  },
  {
    year: "Today",
    title: "Multiple Opportunities",
    text: "Students receive preparation support for engineering, medical, science, defence, architecture and other professional entrance examinations.",
    icon: "target",
  },
];

const EXAMS = [
  {
    title: "Engineering Entrance Examinations",
    icon: "engineering",
    exams: [
      ["MHT-CET", "Maharashtra Common Entrance Test"],
      ["JEE Main", "Joint Entrance Examination Main"],
      ["JEE Advanced", "For admission pathways to IITs"],
      ["BITSAT", "Birla Institute of Technology and Science Admission Test"],
      ["VITEEE", "VIT Engineering Entrance Examination"],
    ],
  },
  {
    title: "Medical Entrance Examination",
    icon: "medical",
    exams: [
      ["NEET-UG", "National Eligibility-cum-Entrance Test for undergraduate medical programmes"],
    ],
  },
  {
    title: "Science & Research",
    icon: "science",
    exams: [
      ["IAT", "IISER Aptitude Test for admission pathways to participating IISER programmes"],
    ],
  },
  {
    title: "Defence Entrance Examination",
    icon: "defence",
    exams: [
      ["NDA", "National Defence Academy and Naval Academy Examination"],
    ],
  },
  {
    title: "Architecture Entrance Examination",
    icon: "architecture",
    exams: [
      ["NATA", "National Aptitude Test in Architecture"],
    ],
  },
];

const ACADEMIC = [
  {
    title: "Concept-Based Teaching",
    icon: "book",
    text: "We simplify complex concepts and focus on building a strong understanding of fundamental principles.",
  },
  {
    title: "Examination-Oriented Preparation",
    icon: "target",
    text: "Our teaching incorporates question-solving techniques, examination patterns, practice strategies and performance improvement.",
  },
  {
    title: "Regular Testing & Analysis",
    icon: "chart",
    text: "Periodic tests help students evaluate preparation, identify weaknesses and monitor progress.",
  },
  {
    title: "Daily Practice Problems (DPPs)",
    icon: "pencil",
    text: "Targeted practice problems reinforce classroom learning and help students improve accuracy, speed and confidence.",
  },
  {
    title: "Structured Study Material",
    icon: "book-open",
    text: "Student-centric Gurukul booklets provide organised learning resources, revision support and examination-focused practice.",
  },
  {
    title: "Continuous Academic Support",
    icon: "support",
    text: "Students receive guidance to resolve doubts, strengthen difficult concepts and improve performance throughout the programme.",
  },
];

const MENTORSHIP = [
  "Understanding individual learning needs",
  "Monitoring academic progress",
  "Identifying weak concepts and topics",
  "Providing doubt-solving support",
  "Guiding students in study planning and revision",
  "Improving time management and examination techniques",
  "Building confidence and consistency",
  "Encouraging students through challenging phases of preparation",
];

const FACULTY_POINTS = [
  "Strong conceptual understanding",
  "Simple and effective explanation",
  "Examination-oriented problem-solving",
  "Systematic doubt resolution",
  "Regular practice and revision",
  "Individual academic guidance",
  "Consistent monitoring of student progress",
];

const STUDY_POINTS = [
  "Understand concepts step by step",
  "Practise questions systematically",
  "Strengthen important topics",
  "Identify recurring mistakes",
  "Improve speed and accuracy",
  "Revise effectively before examinations",
  "Develop confidence in solving competitive-level questions",
];

const TEST_POINTS = [
  "Evaluate conceptual understanding",
  "Assess topic-wise preparation",
  "Identify weak areas",
  "Analyse mistakes",
  "Improve question-selection strategies",
  "Strengthen revision planning",
  "Track academic progress",
];

const LEARNING_ENVIRONMENT = [
  ["Academic Discipline", "A structured environment that encourages consistent effort."],
  ["Faculty Interaction", "Encouraging students to ask questions and seek guidance."],
  ["Peer Learning", "Healthy competition and learning from fellow students."],
  ["Mentorship & Motivation", "Support to remain focused on academic goals."],
  ["Regular Feedback", "Academic feedback to help students identify areas for improvement."],
  ["Parent Communication", "Constructive communication and cooperation with families."],
];

const SUPPORT_FACILITIES = [
  {
    title: "College & Integrated Learning Support",
    icon: "building",
    text: "Gurukul's educational ecosystem includes its own college facilities, helping support an integrated approach to academic learning and competitive preparation, subject to the relevant programme and admission arrangements.",
  },
  {
    title: "Safe & Secure Bus Facility",
    icon: "bus",
    text: "Transportation support is intended to provide students with convenient access to the academy and support regular attendance.",
  },
  {
    title: "Hostel Facilities for Boys & Girls",
    icon: "house",
    text: "Separate hostel facilities support students who require residential accommodation during their academic preparation.",
  },
];

const SCHOLARSHIP_POINTS = [
  "Available courses and fee structures",
  "Merit-based scholarships",
  "Scholarship eligibility criteria",
  "Applicable concessions",
  "Payment schedules and options",
  "Admission and enrolment procedures",
];

const ADVANTAGES = [
  ["Experienced & Dedicated Faculty", "Expert teaching with a focus on conceptual clarity.", "faculty"],
  ["Individual Attention", "Support tailored to individual student learning needs.", "users"],
  ["Personal Mentorship", "Guidance for academic progress and examination preparation.", "mentor"],
  ["Result-Oriented Programmes", "Structured preparation with clear academic goals.", "target"],
  ["Periodic Tests", "Regular assessment and performance review.", "chart"],
  ["Gurukul Booklets & DPPs", "Organised study material and targeted practice.", "book"],
  ["Simple & Effective Teaching", "Making complex concepts easier to understand.", "lightbulb"],
  ["Expert Guidance", "Access to subject specialists and relevant industry expertise, where applicable.", "support"],
  ["Own College Facilities", "Support for integrated academic pathways where available.", "building"],
  ["Safe Transportation", "Convenient travel support for students.", "bus"],
  ["Separate Hostel Facilities", "Residential options for boys and girls.", "house"],
  ["Flexible Fee Structure", "Options explained according to programme requirements.", "wallet"],
  ["Merit Scholarships", "Opportunities for eligible, meritorious students.", "award"],
  ["Parent-Friendly Management", "Communication and cooperation with families.", "handshake"],
  ["Supportive Atmosphere", "An environment that encourages discipline, confidence and continuous improvement.", "heart"],
];

function Icon({ name, size = 26 }) {
  const paths = {
    calendar: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M16 3v4M8 3v4M3 10h18M8 14h3M8 17h5" /></>,
    trophy: <><path d="M8 4h8v5a4 4 0 0 1-8 0V4ZM8 6H4v2a4 4 0 0 0 4 4M16 6h4v2a4 4 0 0 1-4 4M12 13v5M8 21h8M10 18h4" /></>,
    target: <><circle cx="11" cy="13" r="8" /><circle cx="11" cy="13" r="4" /><circle cx="11" cy="13" r="1" /><path d="m13 11 7-7M16 4h4v4" /></>,
    engineering: <><path d="M4 20h16M6 20V9l6-5 6 5v11M9 20v-6h6v6" /><path d="M9 9h.01M15 9h.01" /></>,
    medical: <><path d="M8 3h8v5h5v8h-5v5H8v-5H3V8h5V3Z" /><path d="M12 8v8M8 12h8" /></>,
    science: <><path d="M9 3h6M10 3v6l-5 9a2 2 0 0 0 2 3h10a2 2 0 0 0 2-3l-5-9V3" /><path d="M7 15h10M9 12h.01M14 17h.01" /></>,
    defence: <><path d="M12 22s8-4 8-11V5l-8-3-8 3v6c0 7 8 11 8 11Z" /><path d="m9 12 2 2 4-4" /></>,
    architecture: <><path d="M3 21h18M5 21V8l7-5 7 5v13M9 21v-7h6v7" /><path d="M8 10h.01M12 10h.01M16 10h.01" /></>,
    book: <><path d="M4 4.5A2.5 2.5 0 0 1 6.5 2H12v19H6.5A2.5 2.5 0 0 0 4 23ZM20 4.5A2.5 2.5 0 0 0 17.5 2H12v19h5.5A2.5 2.5 0 0 1 20 23Z" /></>,
    "book-open": <><path d="M2 5a2 2 0 0 1 2-2h6a4 4 0 0 1 4 4v14a4 4 0 0 0-4-4H4a2 2 0 0 0-2 2ZM22 5a2 2 0 0 0-2-2h-4a4 4 0 0 0-4 4v14a4 4 0 0 1 4-4h4a2 2 0 0 1 2 2Z" /></>,
    chart: <><path d="M4 20V4M4 20h17M8 16l4-5 3 2 5-7" /><path d="M16 6h4v4" /></>,
    pencil: <><path d="m14 5 5 5M4 20l4.5-1 10-10a2.1 2.1 0 0 0-3-3l-10 10L4 20Z" /></>,
    support: <><circle cx="12" cy="12" r="9" /><path d="M9.5 9a2.5 2.5 0 1 1 4.4 1.6c-1.1 1-1.9 1.4-1.9 3.4M12 17h.01" /></>,
    users: <><path d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="10" cy="7" r="4" /><path d="M20 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></>,
    building: <><rect x="4" y="2" width="16" height="20" rx="1" /><path d="M9 22v-4h6v4M8 6h2m4 0h2M8 10h2m4 0h2M8 14h2m4 0h2" /></>,
    bus: <><path d="M5 17h14M5 6l1-3h12l1 3M4 6h16v11H4zM7 17v3M17 17v3" /><circle cx="7.5" cy="13" r="1" /><circle cx="16.5" cy="13" r="1" /></>,
    house: <><path d="m3 10 9-7 9 7v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z" /><path d="M9 21v-7h6v7" /></>,
    wallet: <><rect x="3" y="5" width="18" height="15" rx="2" /><path d="M3 9h18M16 14h.01M6 5V3h12v2" /></>,
    award: <><circle cx="12" cy="8" r="6" /><path d="m8 13-1 9 5-3 5 3-1-9" /><path d="m9.5 8 1.5 1.5L14.5 6" /></>,
    handshake: <><path d="m3 12 4-4 5 1 3-2 6 4-7 7-4-3-3 1-4-4Z" /><path d="m7 8 3-3 5 1 3 2M10 14l3 2M12 11l3 3" /></>,
    heart: <><path d="M20.8 8.5c0 5-8.8 10.5-8.8 10.5S3.2 13.5 3.2 8.5A4.5 4.5 0 0 1 12 6.4a4.5 4.5 0 0 1 8.8 2.1Z" /></>,
    faculty: <><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0M18 4l2-2M19 9h3" /></>,
    mentor: <><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0M12 12v5M9 14l3 3 3-3" /></>,
    lightbulb: <><path d="M9 18h6M10 22h4M8 14a6 6 0 1 1 8 0c-1 .8-1.5 1.8-1.5 4h-5c0-2.2-.5-3.2-1.5-4Z" /></>,
    check: <><path d="m5 12 4 4L19 6" /></>,
    arrow: <><path d="M4 12h15M13 5l7 7-7 7" /></>,
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths[name] || paths.lightbulb}
    </svg>
  );
}

function Counter({ value, suffix = "" }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    let frame;
    let started = false;

    const element = ref.current;
    if (!element) return undefined;

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting || started) return;
      started = true;
      observer.disconnect();

      const start = performance.now();
      const duration = 1400;

      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        setCount(Math.round(value * (1 - Math.pow(1 - progress, 3))));

        if (progress < 1) {
          frame = requestAnimationFrame(tick);
        }
      };

      frame = requestAnimationFrame(tick);
    });

    observer.observe(element);

    return () => {
      observer.disconnect();
      if (frame) cancelAnimationFrame(frame);
    };
  }, [value]);

  return (
    <span ref={ref}>
      {count.toLocaleString("en-IN")}
      {suffix}
    </span>
  );
}

function Heading({ eyebrow, title, description }) {
  return (
    <motion.div
      className="im-heading"
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.45 }}
    >
      <span className="im-eyebrow">{eyebrow}</span>
      <h2>{title}</h2>
      {description && <p>{description}</p>}
    </motion.div>
  );
}

function IconCard({ icon, title, text }) {
  return (
    <article className="im-card">
      <div className="im-icon">
        <Icon name={icon} />
      </div>
      <h3>{title}</h3>
      <p>{text}</p>
    </article>
  );
}

export default function IITMedicalAcademyShowcase() {
  const { colors } = useTheme();

  const goTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  /*
   * Uses the SAME theme values as the existing English Academy page.
   * No new fixed colour palette is introduced here.
   */
  const themeStyle = {
    "--im-primary": colors.primary,
    "--im-primary-dark": colors.primaryDark,
    "--im-secondary": colors.secondary,
    "--im-text-light": colors.textLight,
    "--im-hover": colors.hover,
    "--im-overlay": colors.overlay,
    "--im-button-primary": colors.buttonPrimary,
    "--im-button-text": colors.buttonText,
    "--im-text": colors.text,
    "--im-text-secondary": colors.textSecondary,
    "--im-background": colors.background,
    "--im-background-gradient": colors.backgroundGradient,
    "--im-background-alt": colors.backgroundAlt,
    "--im-card": colors.card,
    "--im-border": colors.border,
    "--im-shadow": colors.cardShadow,
  };

  return (
    <div className="im-root" style={themeStyle}>
      <style>{`
        .im-root {
          color: var(--im-text);
          background: var(--im-background);
          font-family: inherit;
          width: 100%;
          overflow: clip;
        }

        .im-root *,
        .im-root *::before,
        .im-root *::after {
          box-sizing: border-box;
        }

        .im-root section {
          scroll-margin-top: 100px;
        }

        .im-wrap {
          width: min(1200px, 100%);
          margin-inline: auto;
        }

        .im-section {
          padding: clamp(2.8rem, 6vw, 5rem) 1.5rem;
          background: var(--im-background);
        }

        .im-section-alt {
          background: var(--im-background-alt);
        }

        .im-heading {
          max-width: 850px;
          margin: 0 auto 2.5rem;
          text-align: center;
        }

        .im-eyebrow {
          display: inline-block;
          margin-bottom: .7rem;
          color: var(--im-secondary);
          font-size: .8rem;
          font-weight: 700;
          letter-spacing: .09em;
          text-transform: uppercase;
        }

        .im-heading h2 {
          margin: 0;
          color: var(--im-text);
          font-size: clamp(1.7rem, 3.6vw, 2.65rem);
          line-height: 1.25;
          font-weight: 750;
          overflow-wrap: anywhere;
        }

        .im-heading p {
          max-width: 760px;
          margin: .85rem auto 0;
          color: var(--im-text-secondary);
          font-size: 1rem;
          line-height: 1.8;
        }

        .im-grid {
          display: grid;
          gap: 1.25rem;
        }

        .im-card {
          min-width: 0;
          padding: 1.45rem;
          background: var(--im-card);
          border: 1px solid var(--im-border);
          border-radius: 1rem;
          box-shadow: var(--im-shadow);
          transition: transform .22s ease, border-color .22s ease, box-shadow .22s ease;
        }

        .im-card:hover {
          transform: translateY(-4px);
          border-color: var(--im-primary);
          box-shadow: 0 12px 28px color-mix(in srgb, var(--im-primary) 13%, transparent);
        }

        .im-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 48px;
          height: 48px;
          margin-bottom: 1rem;
          color: var(--im-primary);
          background: color-mix(in srgb, var(--im-primary) 10%, var(--im-card));
          border: 1px solid color-mix(in srgb, var(--im-primary) 20%, var(--im-border));
          border-radius: .85rem;
          flex-shrink: 0;
        }

        .im-card h3 {
          margin: 0 0 .6rem;
          color: var(--im-text);
          font-size: 1.08rem;
          line-height: 1.45;
        }

        .im-card p {
          margin: 0;
          color: var(--im-text-secondary);
          font-size: .94rem;
          line-height: 1.8;
        }

        /* HERO — theme colours are inherited from ThemeContext */

        .im-hero {
          position: relative;
          isolation: isolate;
          display: flex;
          align-items: center;
          min-height: clamp(500px, 60vw, 690px);
          padding: clamp(3.5rem, 7vw, 6rem) 1.5rem;
          overflow: hidden;
          background: var(--im-primary-dark);
          color: var(--im-text-light);
        }

        .im-hero::before {
          content: "";
          position: absolute;
          inset: 0;
          z-index: -2;
          background-image: url("${HERO_IMAGE}");
          background-size: cover;
          background-position: center;
        }

        .im-hero::after {
          content: "";
          position: absolute;
          inset: 0;
          z-index: -1;
          background: var(--im-overlay);
        }

        .im-hero-content {
          width: min(1200px, 100%);
          margin-inline: auto;
          animation: im-enter .65s ease-out both;
        }

        .im-hero-label {
          display: inline-flex;
          align-items: center;
          gap: .55rem;
          padding: .6rem .85rem;
          border: 1px solid color-mix(in srgb, var(--im-text-light) 35%, transparent);
          border-radius: 999px;
          background: color-mix(in srgb, var(--im-card) 12%, transparent);
          color: var(--im-text-light);
          font-size: .82rem;
          font-weight: 650;
        }

        .im-hero h1 {
          max-width: 900px;
          margin: 1.5rem 0 1rem;
          color: var(--im-text-light);
          font-size: clamp(2.3rem, 5.5vw, 4.7rem);
          font-weight: 800;
          line-height: 1.1;
          letter-spacing: -.035em;
          overflow-wrap: anywhere;
        }

        .im-hero-lead {
          max-width: 780px;
          margin: 0;
          color: var(--im-text-light);
          font-size: clamp(.98rem, 1.5vw, 1.15rem);
          line-height: 1.85;
        }

        .im-hero-tagline {
          margin: 1.15rem 0 0;
          color: var(--im-text-light);
          font-size: 1rem;
          font-weight: 750;
        }

        .im-hero-chips {
          display: flex;
          flex-wrap: wrap;
          gap: .65rem;
          margin-top: 1.5rem;
        }

        .im-chip {
          padding: .5rem .8rem;
          color: var(--im-text-light);
          background: color-mix(in srgb, var(--im-card) 12%, transparent);
          border: 1px solid color-mix(in srgb, var(--im-text-light) 28%, transparent);
          border-radius: .65rem;
          font-size: .85rem;
          font-weight: 650;
        }

        .im-actions {
          display: flex;
          flex-wrap: wrap;
          gap: .8rem;
          margin-top: 1.8rem;
        }

        .im-button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: .55rem;
          min-height: 48px;
          padding: .8rem 1.15rem;
          border: 1px solid var(--im-border);
          border-radius: .7rem;
          cursor: pointer;
          font: inherit;
          font-weight: 700;
          transition: transform .2s ease, background .2s ease;
        }

        .im-button:hover {
          transform: translateY(-2px);
        }

        .im-button-primary {
          color: var(--im-button-text);
          background: var(--im-button-primary);
          border-color: var(--im-button-primary);
        }

        .im-button-outline {
          color: var(--im-text-light);
          background: transparent;
          border-color: var(--im-text-light);
        }

        /* GLANCE */

        .im-glance-grid {
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 1rem;
        }

        .im-stat {
          position: relative;
          padding: 1.45rem 1.2rem;
          overflow: hidden;
          border-top: 3px solid var(--im-primary);
        }

        .im-stat-number {
          color: var(--im-primary);
          font-size: clamp(1.8rem, 3.1vw, 2.6rem);
          font-weight: 800;
          letter-spacing: -.04em;
          line-height: 1.2;
          font-variant-numeric: tabular-nums;
        }

        .im-stat h3 {
          margin: .55rem 0 .45rem;
          font-size: 1rem;
        }

        /* OUR JOURNEY */

        .im-journey-grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 1.2rem;
        }

        .im-journey-card {
          position: relative;
          padding: 1.5rem;
          border: 1px solid var(--im-border);
          border-radius: 1rem;
          background: var(--im-card);
          box-shadow: var(--im-shadow);
          overflow: hidden;
          transition: transform .22s ease, border-color .22s ease;
        }

        .im-journey-card:hover {
          transform: translateY(-4px);
          border-color: var(--im-primary);
        }

        .im-journey-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: .8rem;
          margin-bottom: 1.1rem;
        }

        .im-journey-number {
          font-size: 1.8rem;
          font-weight: 800;
          color: var(--im-primary);
        }

        .im-journey-year {
          display: inline-block;
          padding: .4rem .7rem;
          color: var(--im-button-text);
          background: var(--im-button-primary);
          border-radius: .5rem;
          font-weight: 750;
          font-size: .82rem;
        }

        .im-journey-card h3 {
          margin: .9rem 0 .55rem;
          color: var(--im-text);
          font-size: 1.15rem;
          line-height: 1.4;
        }

        .im-journey-card p {
          margin: 0;
          color: var(--im-text-secondary);
          font-size: .93rem;
          line-height: 1.8;
        }

        .im-quote {
          margin-top: 1.5rem;
          padding: 1.15rem 1.3rem;
          background: var(--im-background-alt);
          border-left: 4px solid var(--im-primary);
          border-radius: 0 .8rem .8rem 0;
          color: var(--im-text);
          line-height: 1.8;
          font-weight: 650;
        }

        /* ENTRANCE EXAMINATIONS */

        .im-exam-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 1.2rem;
        }

        .im-exam-card {
          min-width: 0;
          padding: 1.4rem;
          background: var(--im-card);
          border: 1px solid var(--im-border);
          border-radius: 1rem;
          box-shadow: var(--im-shadow);
          transition: transform .22s ease, border-color .22s ease;
        }

        .im-exam-card:hover {
          transform: translateY(-3px);
          border-color: var(--im-primary);
        }

        .im-exam-head {
          display: flex;
          align-items: flex-start;
          gap: .9rem;
          margin-bottom: 1.1rem;
        }

        .im-exam-head .im-icon {
          margin: 0;
        }

        .im-exam-head h3 {
          margin: .1rem 0 0;
          color: var(--im-text);
          font-size: 1.08rem;
          line-height: 1.5;
        }

        .im-exam-list {
          display: grid;
          gap: .6rem;
          padding: 0;
          margin: 0;
          list-style: none;
        }

        .im-exam-item {
          display: flex;
          align-items: flex-start;
          gap: .65rem;
          padding: .75rem;
          border: 1px solid var(--im-border);
          border-radius: .7rem;
          background: var(--im-background);
        }

        .im-check {
          flex-shrink: 0;
          color: var(--im-primary);
          margin-top: .15rem;
        }

        .im-exam-item strong {
          display: block;
          color: var(--im-text);
          font-size: .92rem;
          line-height: 1.5;
        }

        .im-exam-item span {
          display: block;
          margin-top: .15rem;
          color: var(--im-text-secondary);
          font-size: .84rem;
          line-height: 1.65;
        }

        .im-exam-footer {
          margin: 1.5rem 0 0;
          text-align: center;
          color: var(--im-text);
          font-weight: 750;
          line-height: 1.7;
        }

        /* LISTS & TWO-COLUMN INFORMATION */

        .im-two-col {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 1.25rem;
        }

        .im-list-card {
          padding: 1.5rem;
          background: var(--im-card);
          border: 1px solid var(--im-border);
          border-radius: 1rem;
          box-shadow: var(--im-shadow);
        }

        .im-list-card h3 {
          margin: 0 0 1rem;
          color: var(--im-text);
          font-size: 1.12rem;
          line-height: 1.5;
        }

        .im-check-list {
          display: grid;
          gap: .75rem;
          padding: 0;
          margin: 0;
          list-style: none;
        }

        .im-check-list li {
          display: flex;
          align-items: flex-start;
          gap: .65rem;
          color: var(--im-text-secondary);
          font-size: .93rem;
          line-height: 1.7;
        }

        .im-check-list svg {
          flex-shrink: 0;
          margin-top: .2rem;
          color: var(--im-primary);
        }

        .im-body-copy {
          color: var(--im-text-secondary);
          font-size: .97rem;
          line-height: 1.9;
        }

        .im-body-copy p {
          margin: 0 0 1rem;
        }

        .im-body-copy p:last-child {
          margin-bottom: 0;
        }

        .im-support-grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 1.1rem;
        }

        .im-support-card {
          padding: 1.4rem;
          background: var(--im-card);
          border: 1px solid var(--im-border);
          border-radius: 1rem;
          box-shadow: var(--im-shadow);
        }

        .im-support-card h3 {
          margin: .9rem 0 .55rem;
          color: var(--im-text);
          font-size: 1.08rem;
          line-height: 1.5;
        }

        .im-support-card p {
          margin: 0;
          color: var(--im-text-secondary);
          font-size: .92rem;
          line-height: 1.8;
        }

        .im-advantage-grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 1rem;
        }

        .im-advantage {
          display: flex;
          align-items: flex-start;
          gap: .9rem;
          padding: 1.1rem;
          background: var(--im-card);
          border: 1px solid var(--im-border);
          border-radius: .9rem;
          transition: transform .2s ease, border-color .2s ease;
        }

        .im-advantage:hover {
          transform: translateY(-3px);
          border-color: var(--im-primary);
        }

        .im-advantage .im-icon {
          width: 42px;
          height: 42px;
          margin: 0;
        }

        .im-advantage h3 {
          margin: 0 0 .35rem;
          color: var(--im-text);
          font-size: .97rem;
          line-height: 1.5;
        }

        .im-advantage p {
          margin: 0;
          color: var(--im-text-secondary);
          font-size: .86rem;
          line-height: 1.7;
        }

        /* FINAL CALL TO ACTION */

        .im-final {
          padding: clamp(2.8rem, 6vw, 4.5rem) 1.5rem;
          background: var(--im-background-gradient);
          color: var(--im-text-light);
        }

        .im-final-inner {
          width: min(1000px, 100%);
          margin: 0 auto;
          text-align: center;
        }

        .im-final h2 {
          margin: 0 0 1rem;
          color: var(--im-text-light);
          font-size: clamp(1.8rem, 4vw, 3rem);
          line-height: 1.25;
        }

        .im-final p {
          max-width: 800px;
          margin: 0 auto 1rem;
          color: var(--im-text-light);
          line-height: 1.85;
        }

        .im-final .im-actions {
          justify-content: center;
        }

        @keyframes im-enter {
          from { opacity: 0; transform: translateY(15px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @media (max-width: 950px) {
          .im-glance-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }

          .im-journey-grid,
          .im-support-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }

          .im-advantage-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        }

        @media (max-width: 680px) {
          .im-section {
            padding: 2.8rem 1rem;
          }

          .im-hero {
            min-height: 560px;
            min-height: 78svh;
            padding: 3.5rem 1rem;
          }

          .im-hero h1 {
            font-size: clamp(2rem, 8.8vw, 3rem);
            letter-spacing: -.025em;
          }

          .im-hero-lead {
            font-size: .95rem;
            line-height: 1.8;
          }

          .im-hero-chips {
            gap: .5rem;
          }

          .im-chip {
            padding: .45rem .6rem;
            font-size: .78rem;
          }

          .im-actions {
            flex-direction: column;
            align-items: stretch;
          }

          .im-button {
            width: 100%;
          }

          .im-heading {
            margin-bottom: 1.8rem;
          }

          .im-heading p {
            font-size: .92rem;
          }

          .im-journey-grid,
          .im-exam-grid,
          .im-two-col,
          .im-support-grid,
          .im-advantage-grid {
            grid-template-columns: minmax(0, 1fr);
          }

          .im-card,
          .im-list-card,
          .im-exam-card,
          .im-support-card {
            padding: 1.15rem;
          }

          .im-final {
            padding: 2.8rem 1rem;
          }
        }

        @media (max-width: 420px) {
          .im-glance-grid {
            gap: .7rem;
          }

          .im-stat {
            padding: 1rem .85rem;
          }

          .im-stat-number {
            font-size: clamp(1.65rem, 7vw, 2rem);
          }

          .im-stat h3 {
            font-size: .9rem;
          }

          .im-card p,
          .im-body-copy,
          .im-check-list li {
            font-size: .9rem;
          }

          .im-exam-head {
            gap: .7rem;
          }

          .im-exam-head .im-icon {
            width: 42px;
            height: 42px;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .im-root *,
          .im-root *::before,
          .im-root *::after {
            animation-duration: .01ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: .01ms !important;
          }
        }
      `}</style>

      {/* 01 — HERO */}

      <section className="im-hero" id="im-hero">
        <div className="im-hero-content">
          <div className="im-hero-label">
            <Icon name="book-open" size={17} />
            A Unit of GURUKULM | Gurukul Academy
          </div>

          <h1>
            Gurukul IIT &amp; Medical Academy
          </h1>

          <p className="im-hero-lead">
            Established in 2018, Gurukul IIT &amp; Medical Academy is
            committed to helping students achieve their dreams of entering
            premier engineering, medical, science, defence, architecture and
            other professional institutions.
          </p>

          <p className="im-hero-tagline">
            Your Ambition. Our Guidance. Your Success.
          </p>

          <div className="im-hero-chips">
            <span className="im-chip">Dream Big</span>
            <span className="im-chip">Prepare Smart</span>
            <span className="im-chip">Achieve Excellence</span>
          </div>

          <div className="im-actions">
            <button
              className="im-button im-button-primary"
              onClick={() => goTo("im-exams")}
            >
              Explore Entrance Exams <Icon name="arrow" size={18} />
            </button>

            <button
              className="im-button im-button-outline"
              onClick={() => goTo("admission-inquiry")}
            >
              Admission Enquiry
            </button>
          </div>
        </div>
      </section>

      {/* 02 — GURUKUL AT A GLANCE */}

      <section className="im-section im-section-alt" id="im-glance">
        <div className="im-wrap">
          <Heading
            eyebrow="The Gurukul Difference"
            title="Gurukul at a Glance"
            description="A focused learning environment built around quality teaching, structured preparation, individual attention and continuous student support."
          />

          <div className="im-glance-grid">
            {[
              {
                value: 2018,
                label: "Established",
                text: "A focused journey in competitive examination preparation.",
                icon: "calendar",
              },
              {
                value: 2020,
                label: "Results Since",
                text: "A commitment to student performance and academic outcomes.",
                icon: "trophy",
              },
              {
                value: 5,
                label: "Career Pathways",
                text: "Engineering, medical, science, defence and architecture.",
                icon: "target",
              },
              {
                value: 9,
                label: "Listed Examinations",
                text: "MHT-CET, JEE Main, JEE Advanced, BITSAT, VITEEE, NEET-UG, IAT, NDA and NATA.",
                icon: "book-open",
              },
            ].map((stat) => (
              <article className="im-card im-stat" key={stat.label}>
                <div className="im-icon">
                  <Icon name={stat.icon} />
                </div>
                <div className="im-stat-number">
                  <Counter value={stat.value} />
                </div>
                <h3>{stat.label}</h3>
                <p>{stat.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* 03 — OUR JOURNEY */}

      <section className="im-section" id="im-journey">
        <div className="im-wrap">
          <Heading
            eyebrow="Growing With Purpose"
            title="Our Journey"
            description="Established in 2018. Creating success stories since 2020."
          />

          <div className="im-journey-grid">
            {JOURNEY.map((item, index) => (
              <motion.article
                className="im-journey-card"
                key={item.year}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
              >
                <div className="im-journey-top">
                  <span className="im-journey-number">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <div className="im-icon">
                    <Icon name={item.icon} />
                  </div>
                </div>

                <span className="im-journey-year">{item.year}</span>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </motion.article>
            ))}
          </div>

          <div className="im-quote">
            Our Focus: Strong Concepts. Smart Preparation. Better Performance.
          </div>
        </div>
      </section>

      {/* 04 — COMPREHENSIVE ENTRANCE EXAM PREPARATION */}

      <section className="im-section im-section-alt" id="im-exams">
        <div className="im-wrap">
          <Heading
            eyebrow="Multiple Career Pathways"
            title="Comprehensive Entrance Examination Preparation"
            description="One destination for multiple career pathways. Gurukul IIT & Medical Academy provides coaching for entrance examinations across engineering, medicine, science, defence and architecture."
          />

          <div className="im-exam-grid">
            {EXAMS.map((category) => (
              <article className="im-exam-card" key={category.title}>
                <div className="im-exam-head">
                  <div className="im-icon">
                    <Icon name={category.icon} size={27} />
                  </div>
                  <h3>{category.title}</h3>
                </div>

                <ul className="im-exam-list">
                  {category.exams.map(([name, description]) => (
                    <li className="im-exam-item" key={name}>
                      <span className="im-check">
                        <Icon name="check" size={18} />
                      </span>
                      <div>
                        <strong>{name}</strong>
                        <span>{description}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </div>

          <p className="im-exam-footer">
            Multiple Exams. Multiple Opportunities. One Focused Preparation Journey.
          </p>
        </div>
      </section>

      {/* 05 — OUR ACADEMIC APPROACH */}

      <section className="im-section" id="im-academic">
        <div className="im-wrap">
          <Heading
            eyebrow="Result-Oriented • Student-Centred • Performance-Driven"
            title="Our Academic Approach"
            description="Success in competitive examinations requires more than completing the syllabus. It demands conceptual clarity, disciplined practice, time management, accuracy and the ability to perform under pressure."
          />

          <div className="im-grid" style={{ gridTemplateColumns: "repeat(3, minmax(0, 1fr))" }}>
            {ACADEMIC.map((item) => (
              <IconCard
                key={item.title}
                icon={item.icon}
                title={item.title}
                text={item.text}
              />
            ))}
          </div>

          <div className="im-quote">
            Learn the Concept. Practise the Questions. Master the Examination.
          </div>
        </div>
      </section>

      {/* 06 — SUKSHMA DRASTA */}

      <section className="im-section im-section-alt" id="im-mentorship">
        <div className="im-wrap">
          <Heading
            eyebrow="Individual Attention & Personal Mentorship"
            title="Sukshma Drashta"
            description="Every Student Matters. Every Goal Deserves a Plan."
          />

          <div className="im-two-col">
            <article className="im-list-card">
              <div className="im-icon">
                <Icon name="mentor" size={28} />
              </div>

              <h3>Personal Attention. Purposeful Guidance.</h3>

              <div className="im-body-copy">
                <p>
                  We believe that students perform better when their academic
                  needs are understood and supported.
                </p>
                <p>
                  Our individual attention and mentorship approach aims to
                  identify each student's strengths, learning gaps and
                  improvement areas, helping them prepare with greater
                  confidence and direction.
                </p>
                <p>
                  Through mentorship and regular interaction, we strive to
                  ensure that students do not feel alone in their competitive
                  examination journey.
                </p>
              </div>
            </article>

            <article className="im-list-card">
              <h3>Our Student Support System</h3>
              <ul className="im-check-list">
                {MENTORSHIP.map((item) => (
                  <li key={item}>
                    <Icon name="check" size={18} />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </article>
          </div>

          <div className="im-quote">
            Personal Attention. Purposeful Guidance. Continuous Improvement.
          </div>
        </div>
      </section>

      {/* 07 — EXPERIENCED & DEDICATED FACULTY */}

      <section className="im-section" id="im-faculty">
        <div className="im-wrap">
          <Heading
            eyebrow="Expert Teaching"
            title="Experienced & Dedicated Faculty"
            description="Clear Concepts. Strong Foundations."
          />

          <div className="im-two-col">
            <article className="im-list-card">
              <div className="im-icon">
                <Icon name="faculty" size={28} />
              </div>
              <h3>Expert Teaching & Guidance</h3>
              <div className="im-body-copy">
                <p>
                  Our faculty team is central to the Gurukul learning
                  experience.
                </p>
                <p>
                  Experienced and dedicated educators help students understand
                  challenging topics, develop problem-solving abilities and
                  approach competitive examinations with clarity.
                </p>
                <p>
                  Students also benefit from expert guidance and relevant
                  interactions with industry professionals, subject specialists
                  and other experts, wherever applicable.
                </p>
              </div>
            </article>

            <article className="im-list-card">
              <h3>Our Teaching Approach</h3>
              <ul className="im-check-list">
                {FACULTY_POINTS.map((item) => (
                  <li key={item}>
                    <Icon name="check" size={18} />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </article>
          </div>

          <div className="im-quote">
            Learn from Experts. Think Independently. Perform with Confidence.
          </div>
        </div>
      </section>

      {/* 08 — GURUKUL STUDY MATERIAL & DPP SYSTEM */}

      <section className="im-section im-section-alt" id="im-study-material">
        <div className="im-wrap">
          <Heading
            eyebrow="Designed for Practice"
            title="Gurukul Study Material & DPP System"
            description="Designed for Practice. Built for Performance."
          />

          <div className="im-two-col">
            <article className="im-list-card">
              <div className="im-icon">
                <Icon name="book-open" size={28} />
              </div>

              <h3>Student-Centric Learning Resources</h3>

              <div className="im-body-copy">
                <p>
                  Effective preparation requires the right learning resources
                  and consistent practice.
                </p>
                <p>
                  Gurukul IIT & Medical Academy provides student-centric
                  Gurukul booklets and Daily Practice Problems (DPPs) to
                  support classroom learning and examination preparation.
                </p>
                <p>
                  Our focus is on making learning organised, purposeful and
                  easier to follow.
                </p>
              </div>
            </article>

            <article className="im-list-card">
              <h3>Our Learning Resources Aim to Help Students</h3>
              <ul className="im-check-list">
                {STUDY_POINTS.map((item) => (
                  <li key={item}>
                    <Icon name="check" size={18} />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </article>
          </div>

          <div className="im-quote">
            Understand Better. Practise Regularly. Improve Continuously.
          </div>
        </div>
      </section>

      {/* 09 — PERIODIC TESTS & PERFORMANCE ANALYSIS */}

      <section className="im-section" id="im-tests">
        <div className="im-wrap">
          <Heading
            eyebrow="Measure Progress"
            title="Periodic Tests & Performance Analysis"
            description="Measure Progress. Identify Gaps. Improve Results."
          />

          <div className="im-two-col">
            <article className="im-list-card">
              <div className="im-icon">
                <Icon name="chart" size={28} />
              </div>

              <h3>Regular Testing & Review</h3>

              <div className="im-body-copy">
                <p>
                  Regular testing is an essential part of competitive
                  examination preparation.
                </p>
                <p>
                  Our periodic assessment system helps students become familiar
                  with examination conditions while developing accuracy, speed,
                  time management and confidence.
                </p>
                <p>
                  Tests are not merely a way to measure performance; they are
                  an opportunity to learn, improve and prepare more effectively.
                </p>
              </div>
            </article>

            <article className="im-list-card">
              <h3>The Testing & Review Process</h3>
              <ul className="im-check-list">
                {TEST_POINTS.map((item) => (
                  <li key={item}>
                    <Icon name="check" size={18} />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </article>
          </div>

          <div className="im-quote">
            Every Test Is an Opportunity to Improve.
          </div>
        </div>
      </section>

      {/* 10 — SUPPORTIVE LEARNING ENVIRONMENT */}

      <section className="im-section im-section-alt" id="im-environment">
        <div className="im-wrap">
          <Heading
            eyebrow="Ambition Needs the Right Environment"
            title="Supportive Learning Environment"
            description="Preparing for competitive examinations can be demanding. Students need an environment that encourages discipline, healthy competition, consistent effort and emotional confidence."
          />

          <div className="im-grid" style={{ gridTemplateColumns: "repeat(3, minmax(0, 1fr))" }}>
            {LEARNING_ENVIRONMENT.map(([title, text], index) => (
              <IconCard
                key={title}
                icon={["book", "users", "target", "mentor", "chart", "support"][index]}
                title={title}
                text={text}
              />
            ))}
          </div>

          <div className="im-quote">
            A Supportive Environment for Serious Preparation.
          </div>

          <p className="im-body-copy" style={{ textAlign: "center", marginTop: "1.25rem" }}>
            We aim to help students develop not only examination skills but also
            perseverance, responsibility and self-belief.
          </p>
        </div>
      </section>

      {/* 11 — COLLEGE & INTEGRATED LEARNING SUPPORT */}

      <section className="im-section" id="im-integrated-learning">
        <div className="im-wrap">
          <Heading
            eyebrow="A Connected Academic Journey"
            title="College & Integrated Learning Support"
            description="Access to a structured academic environment helps students manage school or college studies alongside entrance examination preparation."
          />

          <div className="im-two-col">
            <article className="im-list-card">
              <div className="im-icon">
                <Icon name="building" size={28} />
              </div>

              <h3>Connected Academic Learning</h3>

              <div className="im-body-copy">
                <p>
                  Gurukul's educational ecosystem includes its own college
                  facilities, helping support an integrated approach to
                  academic learning and competitive preparation, subject to
                  the relevant programme and admission arrangements.
                </p>
                <p>
                  Our approach aims to reduce unnecessary learning gaps by
                  connecting foundational academic concepts with competitive
                  examination requirements.
                </p>
              </div>
            </article>

            <article className="im-list-card">
              <div className="im-icon">
                <Icon name="book-open" size={28} />
              </div>

              <h3>Information for Students & Parents</h3>

              <div className="im-body-copy">
                <p>
                  Students and parents can contact the academy to understand
                  the available integrated programmes, academic schedules and
                  admission pathways.
                </p>
                <p>
                  The aim is to help students connect their regular academic
                  learning with focused entrance examination preparation.
                </p>
              </div>
            </article>
          </div>

          <div className="im-quote">
            School or College Learning. Competitive Preparation. One Clearer Direction.
          </div>
        </div>
      </section>

      {/* 12 — TRANSPORTATION & HOSTEL FACILITIES */}

      <section className="im-section im-section-alt" id="im-facilities">
        <div className="im-wrap">
          <Heading
            eyebrow="Supporting Students Beyond the Classroom"
            title="Transportation & Hostel Facilities"
            description="We understand that parents consider safety, accommodation and daily convenience important when choosing an academy."
          />

          <div className="im-support-grid">
            {SUPPORT_FACILITIES.map((item) => (
              <article className="im-support-card" key={item.title}>
                <div className="im-icon">
                  <Icon name={item.icon} size={28} />
                </div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>

          <div className="im-quote">
            A Better Learning Experience Begins with the Right Support System.
          </div>
        </div>
      </section>

      {/* 13 — FLEXIBLE FEES & MERIT SCHOLARSHIPS */}

      <section className="im-section" id="im-scholarships">
        <div className="im-wrap">
          <Heading
            eyebrow="Encouraging Merit. Expanding Opportunities."
            title="Flexible Fee Structure & Merit Scholarships"
            description="We believe that deserving students should be encouraged to pursue their academic ambitions."
          />

          <div className="im-two-col">
            <article className="im-list-card">
              <div className="im-icon">
                <Icon name="award" size={28} />
              </div>

              <h3>Supporting Student Potential</h3>

              <div className="im-body-copy">
                <p>
                  Gurukul IIT & Medical Academy offers a flexible fee structure
                  and merit-based scholarship opportunities, subject to the
                  applicable programme, eligibility criteria and scholarship
                  terms.
                </p>
                <p>
                  Our approach aims to support families in exploring suitable
                  academic options while recognising students who demonstrate
                  strong performance and potential.
                </p>
              </div>
            </article>

            <article className="im-list-card">
              <h3>Information Available from the Academy</h3>
              <ul className="im-check-list">
                {SCHOLARSHIP_POINTS.map((item) => (
                  <li key={item}>
                    <Icon name="check" size={18} />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </article>
          </div>

          <div className="im-quote">
            Recognising Merit. Encouraging Ambition. Supporting Potential.
          </div>
        </div>
      </section>

      {/* 14 — PARENT-FRIENDLY MANAGEMENT */}

      <section className="im-section im-section-alt" id="im-parent-management">
        <div className="im-wrap">
          <Heading
            eyebrow="A Partnership Built on Trust"
            title="Parent-Friendly Management"
            description="We recognise that competitive examination preparation is an important journey for both students and their parents."
          />

          <div className="im-two-col">
            <article className="im-list-card">
              <div className="im-icon">
                <Icon name="handshake" size={28} />
              </div>

              <h3>Communication & Cooperation</h3>

              <div className="im-body-copy">
                <p>
                  At Gurukul, we value transparent communication, accessible
                  guidance and constructive parent engagement.
                </p>
                <p>
                  Our parent-friendly approach aims to provide families with
                  clarity regarding academic progress, student performance,
                  course expectations and available support.
                </p>
              </div>
            </article>

            <article className="im-list-card">
              <div className="im-icon">
                <Icon name="users" size={28} />
              </div>

              <h3>A Shared Responsibility</h3>

              <div className="im-body-copy">
                <p>
                  We encourage parents to work in partnership with faculty and
                  mentors so that students receive consistent guidance at both
                  home and the academy.
                </p>
                <p>
                  When parents and educators work together, students move
                  forward with confidence.
                </p>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* 15 — THE GURUKUL ADVANTAGE */}

      <section className="im-section" id="im-advantage">
        <div className="im-wrap">
          <Heading
            eyebrow="Why Students & Parents Choose Gurukul"
            title="The Gurukul Advantage"
            description="A combination of academic guidance, structured practice, mentorship and student-focused support."
          />

          <div className="im-advantage-grid">
            {ADVANTAGES.map(([title, text, icon]) => (
              <article className="im-advantage" key={title}>
                <div className="im-icon">
                  <Icon name={icon} size={22} />
                </div>
                <div>
                  <h3>{title}</h3>
                  <p>{text}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* 16 — OUR COMMITMENT */}

      <section className="im-section im-section-alt" id="im-commitment">
        <div className="im-wrap">
          <Heading
            eyebrow="Our Commitment"
            title="We Prepare Students for Opportunities, Not Just Examinations."
            description="At Gurukul IIT & Medical Academy, we understand that every student has a dream, and every dream deserves focused preparation."
          />

          <div className="im-list-card">
            <div className="im-body-copy">
              <p>
                Our commitment is to provide the academic guidance, structured
                practice, mentorship and supportive environment that students
                need to work towards their aspirations.
              </p>
              <p>
                We encourage students to aim high, work consistently, learn
                from setbacks and approach every challenge with confidence.
              </p>
            </div>
          </div>

          <div className="im-quote">
            Your Dream Deserves Direction. Your Effort Deserves Guidance.
            Your Future Deserves Preparation.
          </div>
        </div>
      </section>

      {/* 17 — ADMISSIONS OPEN */}

      <section className="im-final" id="im-admissions">
        <div className="im-final-inner">
          <Heading
            eyebrow="Gurukul IIT & Medical Academy"
            title="Admissions Open"
            description="Your Journey to a Dream Career Starts Here."
          />

          <p>
            Preparing for JEE, NEET, MHT-CET, BITSAT, VITEEE, IAT, NDA, NATA
            or another entrance examination?
          </p>

          <p>
            Choose a learning environment that combines expert faculty,
            individual attention, structured testing, mentorship and
            student-focused academic support.
          </p>

          <p>
            Join Gurukul IIT &amp; Medical Academy and take the next step
            towards your academic ambitions.
          </p>

          <div className="im-actions">
            <button
              className="im-button im-button-primary"
              onClick={() => goTo("admission-inquiry")}
            >
              Contact for Admissions <Icon name="arrow" size={18} />
            </button>
          </div>

          <p style={{ marginTop: "1.5rem" }}>
            GURUKUL IIT &amp; MEDICAL ACADEMY
            <br />
            A Unit of GURUKULM | Gurukul Academy
            <br />
            Dream Big. Prepare Smart. Achieve Excellence.
          </p>

          <p>
            Contact the academy for course details, scholarships, fees and
            admissions.
          </p>
        </div>
      </section>
    </div>
  );
}
